import { render, staticRenderFns } from "./AddOrEditClub.vue?vue&type=template&id=d3bf66d4&scoped=true"
import script from "./AddOrEditClub.vue?vue&type=script&lang=js"
export * from "./AddOrEditClub.vue?vue&type=script&lang=js"
import style0 from "./AddOrEditClub.vue?vue&type=style&index=0&id=d3bf66d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3bf66d4",
  null
  
)

export default component.exports